export default __webpack_public_path__ + "static/media/about_icon1.45eac67d.svg";